/**
 * Shopify Account drawer footer links (Orders / Profile) come from the
 * Navigation menu titles. On an English storefront those menu titles may still
 * be Chinese — rewrite them using theme locale strings when lang is English.
 * Chinese (and other) storefronts are left untouched.
 */
(function () {
  const ZH_ORDERS = ['订单', '訂單'];
  const ZH_PROFILE = ['个人资料', '個人資料', '个人档案', '個人檔案', '资料', '資料'];

  function getConfig() {
    const el = document.getElementById('jw-account-i18n');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch {
      return null;
    }
  }

  function isEnglishStorefront(config) {
    const iso = (config?.locale || document.documentElement.lang || 'en').toLowerCase();
    return iso === 'en' || iso.startsWith('en-');
  }

  function buildMap(config) {
    const orders = config?.orders || 'Orders';
    const profile = config?.profile || 'Profile';
    const map = {};
    ZH_ORDERS.forEach((zh) => {
      map[zh] = orders;
    });
    ZH_PROFILE.forEach((zh) => {
      map[zh] = profile;
    });
    return map;
  }

  function rewriteString(value, map) {
    if (!value || !/[\u4e00-\u9fff]/.test(value)) return value;
    const trimmed = value.trim();
    if (map[trimmed]) {
      return value.replace(trimmed, map[trimmed]);
    }
    let next = value;
    for (const [zh, en] of Object.entries(map)) {
      if (next.includes(zh)) next = next.split(zh).join(en);
    }
    return next;
  }

  function rewriteNode(node, map) {
    if (!node) return;

    if (node.nodeType === Node.TEXT_NODE) {
      const next = rewriteString(node.textContent || '', map);
      if (next !== node.textContent) node.textContent = next;
      return;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) return;

    for (const attr of ['aria-label', 'title', 'alt']) {
      const current = node.getAttribute?.(attr);
      if (!current) continue;
      const next = rewriteString(current, map);
      if (next !== current) node.setAttribute(attr, next);
    }

    if (node.shadowRoot) rewriteTree(node.shadowRoot, map);

    node.childNodes.forEach((child) => rewriteNode(child, map));
  }

  function rewriteTree(root, map) {
    if (!root) return;
    rewriteNode(root, map);
  }

  function patchAccount(el, map) {
    if (!(el instanceof HTMLElement)) return;
    rewriteTree(el, map);
    if (el.shadowRoot) rewriteTree(el.shadowRoot, map);
    if (el.dataset.jwEnObs === '1') return;
    el.dataset.jwEnObs = '1';
    const targets = [el, el.shadowRoot].filter(Boolean);
    targets.forEach((target) => {
      const obs = new MutationObserver(() => {
        rewriteTree(el, map);
        if (el.shadowRoot) rewriteTree(el.shadowRoot, map);
      });
      obs.observe(target, { childList: true, subtree: true, characterData: true, attributes: true });
    });
  }

  function scan(map) {
    document.querySelectorAll('shopify-account').forEach((el) => patchAccount(el, map));
    document.querySelectorAll('shopify-account-login, shopify-login-button').forEach((el) => {
      rewriteTree(el, map);
      if (el.shadowRoot) rewriteTree(el.shadowRoot, map);
    });
  }

  function boot() {
    const config = getConfig() || {};
    if (!isEnglishStorefront(config)) return;
    const map = buildMap(config);

    const run = () => scan(map);

    customElements.whenDefined('shopify-account').then(run).catch(run);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }

    const bodyObs = new MutationObserver(run);
    bodyObs.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('click', () => {
      requestAnimationFrame(() => setTimeout(run, 0));
    });
  }

  boot();
})();
